import { useEffect, useState } from 'react';
import { FormControl, FormLabel, VStack } from '@chakra-ui/react';

import StrongModal from '../common/StrongModal';
import StrongInput from '../common/StrongInput';
import StrongImageDragDrop from '../common/StrongImageDragDrop';
import StrongTextarea from '../common/StrongTextarea';
import StrongSelect from '../common/StrongSelect';
import StrongSingleSelect from '../common/StrongSingleSelect';

interface EditEquipmentModalProps {
  selectedEquipment?: Equipment;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (
    title: string,
    description: string,
    link: string,
    thumbnail: File | null,
    selectedPrograms: String[],
    type: string,
  ) => void;
  programstitle?: ProgramTitle[];
}

const EditEquipmentModal = ({
  selectedEquipment,
  isOpen,
  onClose,
  onSubmit,
  programstitle,
}: EditEquipmentModalProps) => {
  const [title, setTitle] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [link, setLink] = useState<string>('');
  const [thumbnail, setThumbnail] = useState<File | null>(null);
  const [selectedOptions, setSelectedOptions] = useState<String[]>([]);
  const [equipmentType, setEquipmentType] = useState<string>('exercise-item');

  useEffect(() => {
    setTitle(selectedEquipment?.title || '');
    setDescription(selectedEquipment?.description || '');
    setLink(selectedEquipment?.link || '');
    setThumbnail(null);
    setSelectedOptions(selectedEquipment?.programinfos || []);
    setEquipmentType(selectedEquipment?.type || 'exercise-item');
  }, [selectedEquipment]);

  return (
    <StrongModal
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={() =>
        onSubmit(
          title,
          description,
          link,
          thumbnail,
          selectedOptions,
          equipmentType,
        )
      }
      title={selectedEquipment ? 'Edit Equipment' : 'Create Equipment'}
      isSubmitDisabled={!title}
      body={
        <VStack spacing={4} align='stretch'>
          <FormControl>
            <FormLabel color='gray.600'>Title</FormLabel>
            <StrongInput
              placeholder='Enter title'
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormControl>

          <FormControl>
            <FormLabel color='gray.600'>Description</FormLabel>
            <StrongTextarea
              placeholder='Enter description'
              rows={5}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </FormControl>

          <FormControl>
            <FormLabel color='gray.600'>Link</FormLabel>
            <StrongTextarea
              placeholder='Enter Equipment Link'
              rows={1}
              value={link}
              onChange={(e) => setLink(e.target.value)}
            />
          </FormControl>

          <FormControl>
            <FormLabel color='gray.600'>Thumbnail</FormLabel>
            <StrongImageDragDrop
              onFileSelect={setThumbnail}
              defaultImageUrl={selectedEquipment?.thumbnail}
            />
          </FormControl>
          <FormControl>
            <FormLabel color='gray.600'>Related Program</FormLabel>
            <StrongSelect
              options={programstitle?.map(({ title, _id }) => ({ label: title, value: _id })) || []}
              value={selectedOptions.map((value) => {
                const program_title = programstitle?.find((programtitle) => programtitle._id === value) as ProgramTitle;
                return { label: program_title ? program_title.title : '', value: program_title? program_title._id : '' };
              })}
              onSelectChange={setSelectedOptions}
            />
          </FormControl>

          <FormControl>
            <FormLabel color='gray.600'>Type</FormLabel>
            <StrongSingleSelect
              options={[
                { label: 'Exercise Item', value: 'exercise-item' },
                { label: 'Apparel', value: 'apparel' },
              ]}
              value={[
                {
                  label:
                    equipmentType === 'apparel' ? 'Apparel' : 'Exercise Item',
                  value: equipmentType,
                },
              ]}
              onSelectChange={setEquipmentType}
            />
          </FormControl>
        </VStack>
      }
    />
  );
};

export default EditEquipmentModal;
